/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ScheduledChangeSummary } from './scheduledChangeSummary';

export type GenericApiResponseListScheduledChangeSummaryData = ScheduledChangeSummary[] | null;
